module.exports = __webpack_public_path__ + "static/img/public_banner_h5.36732a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/public_banner_h5.png
// module id = KpOT
// module chunks = 34